import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Instagram } from 'lucide-react';

const Footer = () => {
  const location = useLocation();

  return (
    <footer className="py-12 md:py-20 bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="space-y-8">
          {/* Top Section - Brand, Email, and Social Icons */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            {/* Brand Logo */}
            <div className="w-48 md:w-56">
              <img src="/iraga-logo.png" alt="Iraga Coffee Roastery" className="w-full h-auto object-contain" />
            </div>

            {/* Email - Middle */}
            <div className="space-y-1">
              <p className="text-gray-600 text-sm">Email us:</p>
              <p className="text-gray-900 font-medium text-sm md:text-base">{window.APP_CONFIG?.email || 'iragacoffee@gmail.com'}</p>
            </div>

            {/* Social Media Icons - Right */}
            <div className="flex space-x-4">
              <a
                href={window.APP_CONFIG?.instagram || 'https://www.instagram.com/iragacoffee'}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-70 transition-opacity"
              >
                <Instagram className="w-6 h-6" style={{ color: '#31415A' }} />
              </a>
            </div>
          </div>

          {/* Divider Line */}
          <div className="border-t border-gray-300 w-full"></div>

          {/* Bottom Section - Logo and Navigation */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
            {/* Logo Image */}
            <div className="w-48 md:w-60">
              <img src="/maskot-blue.png" alt="Iraga Mascot" className="w-full object-contain" />
            </div>

            {/* Tagline and Navigation */}
            <div className="space-y-4 md:space-y-6">
              <p className="text-lg md:text-xl font-bold text-left" style={{ color: '#31415A' }}>
                Brewing with heart. Every cup is matter!
              </p>

              <div className="space-y-3">
                <ul className="space-y-2 text-left">
                  <li>
                    <Link
                      to="/wholesale"
                      className={`font-medium hover:translate-x-2 inline-block transition-transform duration-200 ${location.pathname === '/wholesale' ? 'text-black' : 'text-gray-600'
                        }`}
                    >
                      Wholesale
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/work-with-us"
                      className={`font-medium hover:translate-x-2 inline-block transition-transform duration-200 ${location.pathname === '/work-with-us' ? 'text-black' : 'text-gray-600'
                        }`}
                    >
                      Work With Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/our-location"
                      className={`font-medium hover:translate-x-2 inline-block transition-transform duration-200 ${location.pathname === '/our-location' ? 'text-black' : 'text-gray-600'
                        }`}
                    >
                      Our Location
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/blogs"
                      className={`font-medium hover:translate-x-2 inline-block transition-transform duration-200 ${location.pathname === '/blogs' || location.pathname.startsWith('/blogs/') ? 'text-black' : 'text-gray-600'
                        }`}
                    >
                      Blogs
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Quick Links */}
            <div className="space-y-4 text-left">
              <h4 className="text-lg font-bold" style={{ color: '#31415A' }}>Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/our-story" className="text-gray-600 hover:text-black transition-colors">
                    Our Story
                  </Link>
                </li>
                <li>
                  <Link to="/our-space" className="text-gray-600 hover:text-black transition-colors">
                    Our Space
                  </Link>
                </li>
                <li>
                  <Link to="/our-coffee" className="text-gray-600 hover:text-black transition-colors">
                    Our Coffee
                  </Link>
                </li>
              </ul>
            </div>

            {/* Visit Us */}
            <div className="space-y-4 text-left">
              <h4 className="text-lg font-bold" style={{ color: '#31415A' }}>Visit Us</h4>
              <div className="space-y-3 text-gray-600">
                <p className="text-sm">
                  Monday - Sunday<br />
                  <span className="font-medium text-gray-900">07:30 - 22:00</span>
                </p>
                <p className="text-sm">
                  <span className="font-medium text-gray-900">Phone:</span><br />
                  {window.APP_CONFIG?.phone || '+62 811 3888 969'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
